import { render, staticRenderFns } from "./Identity.vue?vue&type=template&id=6aec8088&scoped=true&"
import script from "./Identity.vue?vue&type=script&lang=js&"
export * from "./Identity.vue?vue&type=script&lang=js&"
import style0 from "./Identity.vue?vue&type=style&index=0&id=6aec8088&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aec8088",
  null
  
)

export default component.exports